import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

class ContactUs extends Component {
  render() {
    return (
      <section className="terms">
        <Row>
          <Col xs="12">
            <div className="terms-title-wrap">
              <h2 className="terms-section-title">
                <FormattedMessage
                  id="sidebar.contact"
                  defaultMessage="Contact Us"
                />
              </h2>
            </div>
          </Col>
        </Row>
        <Container fluid>
          <Row className="no-gutters">
            <Col xs="12" className="terms-list">
              <p className="terms-para">
                Η Υπηρεσία GAMELORDS, παρέχεται στην Ελλάδα από την Εταιρεία Sam
                Media BV, με έδρα στην Ολλανδία (Van Diemenstraat 356 1013 CR
                Amsterdam) με αριθμό VAT NL8187 94 859 B01 η οποία είναι
                καταχωρημένη στο οικείο Εμπορικό Επιμελητήριο με αριθμό εγγραφής
              </p>
              <p className="terms-para">
                Συνεπώς, για οποιοδήποτε θέμα μπορείτε να επικοινωνήσετε με το
                Τμήμα Εξυπηρέτησης Πελατών της Εταιρείας Sam Media BV τηλεφωνικά
                στον αριθμό 2112348373 (απλή χρέωση από οποιοδήποτε σταθερό
                τηλέφωνο). Μπορείτε επίσης να επικοινωνήσετε και μέσω email στο
                sam-media.gr@cchelp.co
              </p>
              <p className="terms-para">
                Σε περίπτωση που επιθυμείτε τη διαγραφή σας από κάποια υπηρεσία
                που παρέχει η Εταιρεία Sam Media BV στην Ελλάδα μπορείτε να
                ακολουθήσετε μία από τις παρακάτω διαδικασίες:
              </p>
              <p className="terms-para">
                1. Να αποστείλετε με γραπτό μήνυμα την λέξη  STOP GL στον κωδικό
                54066 ή 54070 με κόστος απλού τυπικού μηνύματος, το οποίο
                ενδέχεται να διαφοροποιείται ανάλογα με τον πάροχο κινητής
                τηλεφωνίας, που έχετε επιλέξει.
              </p>
              <p className="terms-para">
                Μετά την αποστολή του ανωτέρω μηνύματος, θα λάβετε
                άμεσα δωρεάν μήνυμα από το 54005 το οποίο θα επιβεβαιώνει την
                διαγραφή σας από την υπηρεσία/ες.
              </p>
              <p className="terms-para">
                2. Να καλέσετε στο τηλεφωνικό αριθμό 2112348373 του Τμήματος
                Εξυπηρέτησης Πελατών της Εταιρείας Sam Media BV:
              </p>
              <p className="terms-para">
                - Επιλέγοντας (1) και αφού ακολουθήσετε τις ηχογραφημένες
                οδηγίες διαγράφεστε από την Υπηρεσία. (24ωρη Εξυπηρέτηση)
              </p>
              <p className="terms-para">
                - Επιλέγοντας (2) θα εξυπηρετηθείτε από έναν αντιπρόσωπό μας,
                προκειμένου να γίνει η διαγραφή σας (Ώρες Εξυπηρέτησης: 10π.μ.
                ως 6μ.μ)
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/Faq/ContactUs/ContactUs.js